import { Principal } from '../../shared/index';
import { AlertService } from 'ng-jhipster';
import { School, SchoolService } from '../school';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

export abstract class AbstractDialogComponent {

    public schools: School[];

    constructor(
        protected schoolService: SchoolService,
        protected alertService: AlertService,
        protected principal: Principal
    ) { }

    protected loadSchools() {
        this.principal.hasAnyAuthority(['ROLE_ADMIN']).then(isAdmin => {
            if (isAdmin) {
                this.schoolService.query().subscribe(
                    (res: HttpResponse<School[]>) => { this.schools = res.body; }, (res: HttpErrorResponse) => this.onError(res));
            }
        });
    }

    protected onError(error: HttpErrorResponse) {
        this.alertService.error(error.error.message, null, null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/abstract-dialog-component/abstract-dialog.component.ts